import React from "react";
import { Link } from "react-router-dom";
import backIcon from "../../assets/images/public/back-icon.png";
import tickIcon from "../../assets/images/public/tick-icon.png";
import crossIcon from "../../assets/images/public/cross-icon.png";
//  commom-email and phone number
import { emailAddress, phoneNumber } from "../../common";

const getPricingDetails = (isPopular) => {
  const detail = [
    {
      title: "1x Analyst Account",
      available: true,
    },
    {
      title: "Live Game Analysis",
      available: true,
    },
    {
      title: "Video Analysis",
      available: true,
    },
    {
      title: "Location Analysis",
      available: isPopular,
    },
    {
      title: "Video Playlist Editor",
      available: isPopular,
    },
    {
      title: "Online Player Accounts",
      available: isPopular,
    },
    {
      title: "Online Video Storage",
      available: isPopular,
    },
    {
      title: "Unlimited Pattern Notifications",
      available: isPopular,
    },
    {
      title: "Multi-Camera Angles",
      available: isPopular,
    },
  ];
  return detail;
};
class Pricing extends React.Component {
  constructor() {
    super();
    this.state = {
      pricingPayload: [
        {
          title: "Regular",
          popular: false,
          details: getPricingDetails(false),
          price: "1000",
        },
        {
          title: "Regular-Plus",
          popular: true,
          details: getPricingDetails(true),
          price: "2000",
        },
      ],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { pricingPayload } = this.state;
    return (
      <section className="guidlelines-section">
        <div className="guidlelines-container">
          <div className="screen-title-container">
            <div className="screen-title-content">
              <Link className="back-button-container" to="/">
                <img src={backIcon} alt="back" />
              </Link>
              <div>
                Plans & <span>Pricing</span>
              </div>
            </div>
          </div>
          <div className="faq-section">
            <div className="screen-sub-title">
              Try the contendZONE apps, sign-up Get Premium free for 2 weeks
            </div>
            <div className="faq-section-tile-container pricing-section-tile-container">
              {pricingPayload.map((item, index) => (
                <div
                  className="faq-section-tile pricing-section-tile"
                  key={index}
                >
                  <div className="faq-tile-title pricing-tile-title">
                    <span>{item.title}</span>
                    {item.popular && (
                      <span className="pricing-label">Most Popular</span>
                    )}
                  </div>
                  <div className="pricing-list-container">
                    {item.details.map((feature, index) => (
                      <div className="pricing-list-item" key={index}>
                        <img
                          alt=""
                          src={feature.available ? tickIcon : crossIcon}
                        />
                        <div
                          className={`${
                            !feature.available &&
                            "pricing-list-item-not-available"
                          }`}
                        >
                          {feature.title}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="pricing-bottom-container">
                    <div>
                      ${item.price}
                      <span>/ Year</span>
                    </div>
                    <button className="pricing-buy-now">Buy Now</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="faq-support-container">
            If you have any questions, please reply to this email or contact us
            at: <br />
            <span>{emailAddress}</span> or {""} <span>{phoneNumber}</span>
          </div>
        </div>
      </section>
    );
  }
}

export default Pricing;
